
export default function PricingSection() {
  const handleRegister = () => {
    window.open('https://buy.stripe.com/00w7sEaoVdgx2UlapSgIo01', '_blank');
  };

  return (
    <section className="py-16 px-4 bg-teal-50">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-12 text-gray-800">価格</h2>
        
        <div className="bg-white rounded-xl border border-teal-200 shadow-xl hover:shadow-2xl transition-shadow duration-300 p-12">
          <div className="text-4xl sm:text-6xl font-bold text-teal-600 mb-4 whitespace-nowrap">
            月額800円
          </div>
          <p className="text-gray-600 mb-8 text-lg">シンプルで分かりやすい料金体系</p>
          <div className="flex justify-center">
            <button 
              onClick={handleRegister}
              className="bg-teal-600 hover:bg-teal-700 text-white font-semibold px-8 py-4 text-lg rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              クレジットカードで登録する
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}